export default __webpack_public_path__ + "static/media/electricity.9226ba98.svg";